import { cssRule } from 'typestyle';
import { BlackOpacity30, Blue20, Blue80, Red80, White, WhiteOpacity70 } from '@traceair/tds';

cssRule('.pano-marker', {
  opacity: 0.9,
  $nest: {
    '.pano-marker__border': {
      stroke: BlackOpacity30,
    },
    '.pano-marker__body': {
      fill: White,
    },
  },
});

cssRule('.pano-marker--uploading', {
  $nest: {
    '.pano-marker__border': {
      stroke: BlackOpacity30,
    },
    '.pano-marker__circle': {
      fill: Blue20,
    },
  },
});

cssRule('.pano-marker--uploaded-valid', {
  $nest: {
    '.pano-marker__border': {
      stroke: WhiteOpacity70,
    },
    '.pano-marker__body': {
      fill: Blue80,
    },
    '.pano-marker__circle': {
      fill: Blue80,
    },
  },
});

cssRule('.pano-marker--uploaded-invalid', {
  $nest: {
    '.pano-marker__border': {
      stroke: WhiteOpacity70,
    },
    '.pano-marker__body': {
      fill: Red80,
    },
    '.pano-marker__circle': {
      fill: Red80,
    },
  },
});

export const PanoMarker = () => {
  return (
    <svg
      className="pano-marker"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99834 19.25V19.2501L10.0029 19.25L10.0096 19.25C10.4166 19.2499 10.7314 19.0993 10.9516 18.8194C11.1234 18.6011 11.2175 18.3205 11.2862 18.1159C11.2901 18.1044 11.2939 18.0931 11.2976 18.0821C11.3748 17.8532 11.4441 17.6523 11.5564 17.4607C11.9378 16.81 12.2287 16.5053 12.569 16.3044C15.7261 15.2361 18 12.253 18 8.73764C18 4.32541 14.4175 0.75 10 0.75C5.5825 0.75 2 4.32541 2 8.73764C2 12.2598 4.28276 15.2477 7.44941 16.3106C7.78491 16.5114 8.0738 16.8162 8.45159 17.4607C8.56392 17.6523 8.63321 17.8532 8.7104 18.0821C8.71412 18.0931 8.71791 18.1044 8.72178 18.1159C8.79044 18.3205 8.8846 18.6011 9.05638 18.8194C9.27654 19.0993 9.59139 19.2499 9.99834 19.25Z"
        className="pano-marker__border"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3629 15.8702C15.3473 14.8803 17.5 12.0665 17.5 8.75C17.5 4.60786 14.1421 1.25 10 1.25C5.85786 1.25 2.5 4.60786 2.5 8.75C2.5 12.0736 4.66192 14.8923 7.65622 15.8765C8.11526 16.1379 8.46705 16.5235 8.88295 17.2342C9.02491 17.4767 9.10854 17.7251 9.18419 17.9498C9.34082 18.4151 9.46326 18.7788 9.99845 18.7789L10.004 18.7788L10.0095 18.7789C10.5447 18.7788 10.6672 18.4151 10.8238 17.9498C10.8994 17.7251 10.9831 17.4767 11.125 17.2342C11.5443 16.5177 11.8984 16.1316 12.3629 15.8702Z"
        className="pano-marker__body"
      />

      <circle cx="10" cy="8.75" r="3.75" className="pano-marker__circle" />
    </svg>
  );
};
